import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { AuthService } from 'app/core/auth/auth.service';
import { AppState } from 'app/store/app.reducer';
import { of, switchMap } from 'rxjs';

export const AuthGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);
    const authService = inject(AuthService);
    const store = inject(Store<AppState>);

    return authService.check().pipe(
        switchMap((authenticated) => {
            if (!authenticated) {
                const redirectURL = state.url === '/sign-out' ? '' : `redirectURL=${state.url}`;
                return of(router.parseUrl(`sign-in?${redirectURL}`));
            }

            const actualUser = JSON.parse(localStorage.getItem('actualUser'));

            if (!actualUser?.codigoInstalacion && state.url !== '/setup-onboarding') {
                return of(router.parseUrl('setup-onboarding'));
            }

            return of(true);
        })
    );
};
